module.exports = ".ms-login-btn {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  background-color: #FFFFFF; /* sfondo ufficiale */\r\n  color: #000000;            /* testo */\r\n  border: 1px solid #8C8C8C; /* bordo */\r\n  border-radius: 2px;\r\n  width: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main